import { render, staticRenderFns } from "./verificacao.vue?vue&type=template&id=bdcb5dd2&scoped=true&"
import script from "./verificacao.vue?vue&type=script&lang=js&"
export * from "./verificacao.vue?vue&type=script&lang=js&"
import style0 from "./verificacao.vue?vue&type=style&index=0&id=bdcb5dd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcb5dd2",
  null
  
)

export default component.exports